import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureSet } from '../../models/feature.model';
import { AuthService } from '../../services/auth/auth.service';
import { FeatureService } from '../../services/feature/feature.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const feature = inject(FeatureService);
  const featureSet = route.data['featureSet'] as FeatureSet | undefined;
  const dccCode = route.paramMap.get('dccCode') || undefined;
  let isAuthenticated = false;
  try {
    isAuthenticated = await auth.initializeAuth();

    if (isAuthenticated && auth.shouldRefreshPoliciesForDcc(dccCode)) {
      const policiesLoaded = await auth.refreshPoliciesForDcc(dccCode);
      if (!policiesLoaded) {
        if (auth.isPolicyAccessDenied()) {
          const featureLabel = route.data['featureLabel'] as string | undefined;
          if (!featureLabel) {
            return true;
          }

          const returnTo = state.url.split('/').slice(0, 3).join('/');
          return router.createUrlTree([returnTo, 'access-denied'], {
            queryParams: {
              returnTo,
              feature: featureLabel,
              attemptedRoute: route.routeConfig?.path,
              ...auth.getPolicyAccessDeniedQueryParams(dccCode),
            },
          });
        }

        isAuthenticated = false;
      }
    }
  } catch (e) {
    isAuthenticated = false;
  }

  if (!isAuthenticated) {
    if (auth.isPolicyAccessDenied()) {
      return router.createUrlTree(['/access-denied'], {
        queryParams: auth.getPolicyAccessDeniedQueryParams(dccCode),
      });
    }

    return router.createUrlTree(['/login']);
  }

  if (!feature.canView(featureSet)) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
